<template>
    <v-card>
        <v-card-text>
            <v-form>
                <v-row>
                    <v-col align="right">
                        <v-label> ชื่อสมาชิก : </v-label>
                    </v-col>
                    <v-col align="left"><v-label><strong>{{ member ? member.display_name : "" }}</strong></v-label></v-col>
                </v-row>
                <v-row>
                    <v-col align="right">
                        <v-label> วันที่นัดหมาย : </v-label>
                    </v-col>
                    <v-col align="left"><v-label><strong>{{ date }}</strong></v-label></v-col>
                </v-row>
                <v-row>
                    <v-col align="right">
                        <v-label> ช่วงเวลา : </v-label>
                    </v-col>
                    <v-col align="left"><v-label><strong>
                        {{('0000' + timestart).substring((''+timestart).length,(''+timestart).length+2)}}:{{('0000' + timestart).substring((''+timestart).length+2,(''+timestart).length+4)}} 
                        - {{('0000' + timeend).substring((''+timeend).length,(''+timeend).length+2)}}:{{('0000' + timeend).substring((''+timeend).length+2,(''+timeend).length+4)}} </strong></v-label></v-col>
                </v-row>
                <v-row>
                    <v-col align="right">
                        <v-label> กลุ่มงานบริการ : </v-label>
                    </v-col>
                    <v-col align="left"><v-label><strong>{{ group_name }}</strong></v-label></v-col>
                </v-row>
                <v-row>
                    <v-col align="right" v-if="extranote.length>0">
                        <v-label> ข้อมูลนัดเพิ่มเติม : </v-label>
                    </v-col>
                    <v-col align="left"><v-label><strong>{{ extranote.map(e=>e.extranote_value).join(',') }}</strong></v-label></v-col>
                </v-row>
            </v-form>
            
            <v-row>
                <v-col class="text-right">
                    <v-btn color="primary" @click="backClick">ย้อนกลับ</v-btn> &nbsp;
                    <v-btn color="primary" @click="confirmAppointment">ยืนยัน</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

import config from '@/../config.js'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
    props: ['station_code','member','group_id','group_name','date','timestart','timeend','extranote'],
    methods: {
        confirmAppointment() {
            var que = this.$store.commit('addLoading')
            var data = {
                member_id:this.member.member_id
                ,station_code : this.station_code
                ,reservation_date:this.date
                ,group_id:this.group_id
                ,reservation_timestart:this.timestart
                ,reservation_timeend:this.timeend
            }
            if(this.extranote.length>0){
                data['extranote_list'] = this.extranote
            }
            axios
            .post(config.api.url.manage.appointment.manage.add_appointment,data,{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.$store.commit('finishLoading',que)
                this.$emit('onConfirmAppointment');
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
            
        },
        backClick() {
            this.$emit('onBackClick');
        }
    }

}
</script>